import { useShallow } from 'zustand/react/shallow';
import { LoadingSpinner } from '../LoadingSpinner';
import { ValidationOverrideModal } from './ValidationOverrideModal';
import { useParameterStore, ValidationStatus } from '@/frontend/store/ParameterStore';
import { useValidationStore, VALIDATION_STATUS } from '@/frontend/store/ValidationStore';
import { I18n } from '@/i18n/I18n';
import { CONTEXT_LOG_SUBJECT_TYPES } from '@/types/contextLogTypes';
import { OPERAND_TYPE } from '@/types/validationTypes';
import { Parameter } from '@/backend/models/parameter';
import { Validation } from '@/backend/models/validation';
import { comparisonCharaterFromRuleType } from '@/frontend/components/validations/utils';
import ContextLogViewer from '../contextLogs/ContextLogViewer';

interface ValidationRunSimplifiedViewProps {
  validation: Validation;
  showButtons?: boolean;  
}

export function ValidationRunSimplifiedView({ validation, showButtons = true }: ValidationRunSimplifiedViewProps) {
  const parameters = useParameterStore(useShallow(state => state.parameters.filter((p: Parameter) => p.subjectId === validation.id)));
  const validationStatus = useParameterStore(useShallow(state => state.getValidationStatus(validation.id)));
  const operandB = parameters.find((p) => p.identifier === OPERAND_TYPE.OPERAND_B)?.fields[0];

  const validationState = useValidationStore(state => state.validationStates[validation.id]);
  const isRunning = validationState === VALIDATION_STATUS.RUNNING;

  const operandBValue = operandB?.asString();
  const comparisonOperator = comparisonCharaterFromRuleType(validation.ruleType);

  return (
    <div>
      <div className={`d-flex align-items-center gap-2 ${operandBValue === '' || validationStatus === ValidationStatus.PASSING || validationStatus === ValidationStatus.OVERIDDEN ? 'text-muted' : 'text-danger'}`}>
        <dl className="d-flex align-items-center gap-2 mb-0">
          <dt className='visually-hidden'>{I18n.get('operator')}</dt>
          <dd className='font-monospace small flex-shrink-0 px-1 mb-0'>
            {comparisonOperator}
          </dd>

          <dt className='visually-hidden'>{I18n.get('inputData')}</dt>
          <dd className='font-monospace small px-2 py-1 mb-0'
              title={operandBValue}>
            {operandBValue || '-'}
          </dd>
        </dl>

        {isRunning && (
          <div className="d-flex align-items-center gap-1 ms-2" aria-label={I18n.get('validationRunning')}>
            <LoadingSpinner />
          </div>
        )}
        { (validationStatus === ValidationStatus.FAILING && showButtons) && <ValidationOverrideModal validationId={validation.id} /> }
        { validationStatus === ValidationStatus.OVERIDDEN && <ContextLogViewer subjectId={validation.id} subjectType={CONTEXT_LOG_SUBJECT_TYPES.VALIDATION} popoverPlacement='bottom' allowDelete /> }
      </div>
    </div>
  );
}
